import { IconButton, Typography, useTheme } from '@mui/material'

import { DeleteIcon } from 'src/assets/icons'
import { IMediaFileWithId } from 'src/types'

import useStyles from './styles'
import { MediaImageRender } from './media-image-render.component'
import { MediaImagePreview } from './media-image-previev.component'
import { EyeOpenedIcon } from 'src/assets/icons/v2/EyeOpenedIcons'

interface IMediaImageProps {
  handleRemove?: () => void
  link: string
  alt: string
  handleImageClick?: () => void
  type: string
  title?: IMediaFileWithId['title']
  link_medium?: string | null
  isDisabled?: boolean
  showPreview?: boolean
}

const MediaImage = ({
  handleRemove,
  link,
  alt,
  handleImageClick,
  type,
  title,
  link_medium,
  isDisabled,
  showPreview = false,
}: IMediaImageProps) => {
  const theme = useTheme()
  const classes = useStyles({ isModalImage: !title })

  return (
    <div className={classes.imageItemWrapper}>
      <div className={classes.imageWrapper}>
        <IconButton
          className={classes.imageButton}
          onClick={handleImageClick}
          disabled={!handleImageClick || isDisabled}
        >
          <MediaImageRender
            className={classes.image}
            alt={alt}
            link={link_medium || link}
            type={type}
          />
        </IconButton>
        {handleRemove && (
          <IconButton
            aria-label="delete"
            className={classes.removeImageButton}
            onClick={handleRemove}
          >
            {!isDisabled && <DeleteIcon className={classes.removeImage} />}
          </IconButton>
        )}
        {showPreview && (
          <IconButton
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              minWidth: 20,
              width: 35,
              height: 35,
              padding: 0,
              borderRadius: '50%',
              backgroundColor: theme.palette.custom.greyTransparent,
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 15,
              transition: 'background 0.3s ease',

              '&:hover': {
                backgroundColor: theme.palette.custom.grey,
              },
            }}
            aria-label="open-preview"
            disabled={isDisabled}
          >
            {!isDisabled && (
              <MediaImagePreview link={link} type={type}>
                <EyeOpenedIcon size={35} color={theme.palette.custom.darkBlue2} />
              </MediaImagePreview>
            )}
          </IconButton>
        )}
      </div>
      {title && (
        <div className={classes.imageTitleWrapper}>
          <Typography className={classes.imageTitle}>{title}</Typography>
        </div>
      )}
    </div>
  )
}

export { MediaImage }
